var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemType = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  d: "M6.126 13.573a1 1 0 0 1 1.748 0l3.3 5.942a1 1 0 0 1-.734 1.475l-.14.01H3.7a1 1 0 0 1-.875-1.485zm13.266-.702a1 1 0 0 1 .721.507l.065.142 1.308 3.627a1 1 0 0 1-.392 1.176l-3.547 2.32a1 1 0 0 1-1.094 0l-3.547-2.32a1 1 0 0 1-.393-1.177l1.31-3.626.064-.142c.148-.271.415-.459.72-.507l.157-.012h4.472zM5.398 19h3.203L7 16.117zm9.266-1.917L17 18.61l2.337-1.527-.803-2.224h-3.068zM7 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8m13 0a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zM7 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m8 4h4V5h-4z"
})));
export default SvgGemType;